export const quoteRevisionsBaseKey = ["quote-revisions"] as const

export const quoteRevisionsKey = (quoteId: string) =>
  [...quoteRevisionsBaseKey, quoteId] as const
